import script from "./ViewAxios.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewAxios.vue?vue&type=script&setup=true&lang=js"

import "./ViewAxios.vue?vue&type=style&index=0&id=625760c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-625760c6"]])

export default __exports__